<template>
  <div class="wrapper">
    <el-dialog
      :title="rowId ? '编辑商品' : '新增商品'"
      :visible.sync="showAddOrEdit"
      width="800px"
      :before-close="cancelFun"
      class="goods-dialog"
    >
      <div class="dialog-content">
        <el-form ref="form" :model="formData" class="wrapper-form" label-width="120px">
          <el-form-item label="品牌" prop="goodsBrand" :rules="rules">
            <el-select
              v-model="formData.goodsBrand"
              placeholder="请选择品牌"
              clearable
              class="form-select"
            >
              <el-option v-for="item in brandList" :key="item.enumCode" :label="item.enumText" :value="item.enumCode" />
            </el-select>
          </el-form-item>
          <el-form-item label="型号" prop="model" :rules="rules">
            <el-select 
              v-model="formData.model" 
              placeholder="请选择型号" 
              clearable
              class="form-select"
            >
              <el-option v-for="item in modelList" :key="item.enumCode" :label="item.enumText" :value="item.enumCode" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="goodsType == dict.EnumGoodsType.C3" label="内存" prop="memory" :rules="rules">
            <el-select 
              v-model="formData.memory" 
              placeholder="请选择内存" 
              clearable
              class="form-select"
            >
              <el-option v-for="item in memoryList" :key="item.enumCode" :label="item.enumText" :value="item.enumCode" />
            </el-select>
          </el-form-item>
          <el-form-item label="颜色" prop="colorList" :rules="rules">
            <el-select 
              v-model="formData.colorList" 
              placeholder="请选择颜色（可多选）" 
              multiple 
              clearable
              class="form-select"
            >
              <el-option v-for="item in colorList" :key="item.enumText" :label="item.enumText" :value="item.enumCode" />
            </el-select>
          </el-form-item>
          <el-form-item label="封面图" prop="coverImage" :rules="rules">
            <FileUpload :name.sync="formData.coverImage" :url="formData.coverImageUrl"></FileUpload>
          </el-form-item>
          <el-form-item label="官网价" prop="officialPrice" :rules="rules">
            <el-input-number 
              v-model="formData.officialPrice" 
              :precision="2" 
              :step="0.01" 
              :min="0"
              :controls="false"
              placeholder="请输入官网价"
              class="form-input-number"
            ></el-input-number>
            <span class="form-tip">元</span>
          </el-form-item>
          <el-form-item label="到期申请购买价" prop="buyoutPrice" :rules="rules">
            <el-input-number 
              v-model="formData.buyoutPrice" 
              :precision="2" 
              :step="0.01" 
              :min="0"
              :controls="false"
              placeholder="请输入到期申请购买价"
              class="form-input-number"
            ></el-input-number>
            <span class="form-tip">元</span>
          </el-form-item>
          <el-form-item label="全新售价" prop="minPrice" :rules="rules">
            <div class="price-range">
              <el-input-number 
                v-model="formData.minPrice" 
                :precision="2" 
                :step="0.01" 
                :min="0"
                :controls="false"
                placeholder="最低价"
                class="form-input-number-range"
              ></el-input-number>
              <span class="range-separator">~</span>
              <el-input-number 
                v-model="formData.maxPrice" 
                :precision="2" 
                :step="0.01" 
                :min="0"
                :controls="false"
                placeholder="最高价"
                class="form-input-number-range"
              ></el-input-number>
              <span class="form-tip">元</span>
            </div>
          </el-form-item>
          <el-form-item label="二手售价" prop="oldMinPrice" :rules="rules">
            <div class="price-range">
              <el-input-number 
                v-model="formData.oldMinPrice" 
                :precision="2" 
                :step="0.01" 
                :min="0"
                :controls="false"
                placeholder="最低价"
                class="form-input-number-range"
              ></el-input-number>
              <span class="range-separator">~</span>
              <el-input-number 
                v-model="formData.oldMaxPrice" 
                :precision="2" 
                :step="0.01" 
                :min="0"
                :controls="false"
                placeholder="最高价"
                class="form-input-number-range"
              ></el-input-number>
              <span class="form-tip">元</span>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" size="small" @click="cancelFun" class="cancel-btn">取 消</el-button>
        <el-button type="primary" size="small" @click="submitFun" class="submit-btn">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getBrandListAPI, getAttrListAPI, getDetailAPI, addAPI, editAPI } from './api';
import { EnumGoodsType } from "@/enum/dict/index.js";
import FileUpload from '@/components/file-upload/index.vue';

export default {
  name: 'StoreGoodsAddOrEdit',
  components: { FileUpload },
  props: {
    showAddOrEdit: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: Number,
      default: null,
    },
    goodsType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      rules: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
      dict: {
        EnumGoodsType
      },
      brandList: [],
      modelList: [],
      memoryList: [],
      colorList: [],
      formData: {
        goodsType: '',
        goodsBrand: '',
        model: '',
        memory: '',
        colorList: [],
        coverImage: '',
        officialPrice: '',
        minPrice: '',
        maxPrice: '',
        oldMinPrice: '',
        oldMaxPrice: '',
        buyoutPrice: ''
      }
    }
  },
  mounted() {
    this.getBrandList();
    this.getModelList();
    if (this.goodsType == EnumGoodsType.C3) {
      this.getMemoryList();
    }
    this.getColorList();
    if (this.rowId) this.getGoodsDetail();
  },
  methods: {
    async getBrandList() {
      this.brandList = await getBrandListAPI({
        goodsType: this.goodsType,
      });
    },
    async getModelList() {
      let params = { goodsType: this.goodsType, groupCode: 'model' };
      const res = await getAttrListAPI(params);
      this.modelList = res || [];
    },
    async getMemoryList() {
      let params = { goodsType: this.goodsType, groupCode: 'memory' };
      const res = await getAttrListAPI(params);
      this.memoryList = res || [];
    },
    async getColorList() {
      let params = { goodsType: this.goodsType, groupCode: 'color' };
      const res = await getAttrListAPI(params);
      this.colorList = res || [];
    },
    async getGoodsDetail() {
      this.formData = await getDetailAPI(this.rowId);
    },
    submitFun() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.formData.goodsType = this.goodsType;
          if (this.formData.id) {
            editAPI(this.formData).then(() => {
              this.$message.success('编辑成功');
              this.$emit("closeDialog", true);
            })
          } else {
            addAPI(this.formData).then(() => {
              this.$message.success('新增成功');
              this.$emit("closeDialog", true);
            })
          }
        }
      })
    },
    cancelFun() {
      this.$emit("closeDialog");
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
}

// 对话框样式
::v-deep .goods-dialog {
  .el-dialog {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15), 0 4px 16px rgba(0, 0, 0, 0.1);
    
    .el-dialog__header {
      padding: 20px 24px;
      background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
      border-bottom: none;
      
      .el-dialog__title {
        font-size: 18px;
        font-weight: 600;
        color: #fff;
      }
      
      .el-dialog__headerbtn {
        top: 20px;
        right: 24px;
        
        .el-dialog__close {
          font-size: 20px;
          color: #fff;
          transition: all 0.3s ease;
          
          &:hover {
            color: rgba(255, 255, 255, 0.8);
          }
        }
      }
    }
    
    .el-dialog__body {
      padding: 0;
      background: #ffffff;
    }
    
    .el-dialog__footer {
      padding: 20px 28px;
      background: linear-gradient(135deg, #fafbfc 0%, #f5f7fa 100%);
      border-top: 2px solid #f0f2f5;
    }
  }
}

.dialog-content {
  padding: 24px 28px;
  max-height: 60vh;
  overflow-y: auto;
  
  // 自定义滚动条
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f5f7fa;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c0c4cc;
    border-radius: 3px;
    
    &:hover {
      background: #909399;
    }
  }
}

.wrapper-form {
  .el-form-item {
    margin-bottom: 24px;
    
    .el-form-item__label {
      color: #303133;
      font-weight: 600;
      letter-spacing: 0.3px;
      font-size: 14px;
      position: relative;
      
      &::after {
        content: ':';
        margin-left: 2px;
        color: #909399;
      }
    }
    
    .el-form-item__content {
      .form-select {
        width: 400px;
        
        ::v-deep .el-input__inner {
          border-radius: 10px;
          height: 42px;
          line-height: 42px;
          border: 1.5px solid #E4E7ED;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          background: #fafbfc;
          font-size: 14px;
          padding-left: 15px;

          &:hover {
            border-color: #C0C4CC;
            background: #ffffff;
          }
        }
        
        &.is-active .el-input__inner,
        .el-input__inner:focus {
          border-color: #409EFF;
          box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
          background: #ffffff;
        }
      }
      
      .form-input-number {
        width: 400px;
        
        ::v-deep {
          .el-input-number__decrease,
          .el-input-number__increase {
            display: none;
          }
          
          .el-input {
            .el-input__inner {
              border-radius: 10px;
              height: 42px;
              line-height: 42px;
              border: 1.5px solid #E4E7ED;
              transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
              background: #fafbfc;
              font-size: 14px;
              text-align: left;
              padding: 0 15px;
              box-sizing: border-box;

              &:hover {
                border-color: #C0C4CC;
                background: #ffffff;
              }
              
              &:focus {
                border-color: #409EFF;
                box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
                background: #ffffff;
              }
            }
          }
        }
      }
      
      .form-input-number-range {
        width: 190px;
        
        ::v-deep {
          .el-input-number__decrease,
          .el-input-number__increase {
            display: none;
          }
          
          .el-input {
            .el-input__inner {
              border-radius: 10px;
              height: 42px;
              line-height: 42px;
              border: 1.5px solid #E4E7ED;
              transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
              background: #fafbfc;
              font-size: 14px;
              text-align: left;
              padding: 0 15px;
              box-sizing: border-box;

              &:hover {
                border-color: #C0C4CC;
                background: #ffffff;
              }
              
              &:focus {
                border-color: #409EFF;
                box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
                background: #ffffff;
              }
            }
          }
        }
      }
      
      .price-range {
        display: flex;
        align-items: center;
        gap: 12px;
        
        .range-separator {
          color: #909399;
          font-weight: 600;
          font-size: 16px;
          padding: 0 4px;
        }
      }
      
      .form-tip {
        margin-left: 12px;
        font-size: 12px;
        color: #909399;
      }
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  
  .cancel-btn {
    border-radius: 10px;
    padding: 10px 24px;
    font-weight: 600;
    font-size: 13px;
    background: linear-gradient(135deg, #a4a9b0 0%, #909399 100%);
    border: none;
    box-shadow: 0 2px 8px rgba(144, 147, 153, 0.25);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    letter-spacing: 0.3px;

    &:hover {
      background: linear-gradient(135deg, #909399 0%, #82848a 100%);
      box-shadow: 0 4px 12px rgba(144, 147, 153, 0.35);
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(144, 147, 153, 0.25);
    }
  }
  
  .submit-btn {
    border-radius: 10px;
    padding: 10px 24px;
    font-weight: 600;
    font-size: 13px;
    background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
    border: none;
    box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    letter-spacing: 0.3px;

    &:hover {
      background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
      box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
    }
  }
}

// 文件上传组件样式优化
::v-deep .avatar-uploader {
  .el-upload {
    border: 2px dashed #d9d9d9;
    border-radius: 12px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;
    background: #fafbfc;
    
    &:hover {
      border-color: #409EFF;
      background: #f0f7ff;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
    }
  }
  
  .avatar-uploader-icon {
    font-size: 32px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
    transition: all 0.3s ease;
    
    &:hover {
      color: #409EFF;
    }
  }
  
  .avatar {
    width: 148px;
    height: 148px;
    display: block;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    
    &:hover {
      transform: scale(1.02);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  ::v-deep .goods-dialog {
    .el-dialog {
      width: 95% !important;
      margin: 5vh auto;
    }
    
    .el-dialog__header {
      padding: 16px 20px;
    }
    
    .el-dialog__footer {
      padding: 16px 20px;
    }
  }
  
  .dialog-content {
    padding: 16px 20px;
  }
  
  .wrapper-form {
    .el-form-item {
      .el-form-item__content {
        .form-select,
        .form-input-number {
          width: 100% !important;
        }
        
        .price-range {
          flex-wrap: wrap;
          
          .form-input-number-range {
            width: calc(50% - 6px);
          }
        }
      }
    }
  }
}
</style>
